import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinkharadi() {

const cardData = {
keyword: "Corporate Cab Service in Kharadi",
headingDescription: "Citysky Cabs provides corporate cab services in Kharadi for IT companies, offices, employees, executives, business visitors, and organizations requiring dependable daily transportation. Services can be arranged for employee pickup and drop, EON IT Park travel, airport transfers, office commuting, corporate meetings, guest transportation, and outstation business journeys. With comfortable AC vehicles, professional drivers, flexible rental options, and scheduled routes, businesses in Kharadi can manage regular employee and corporate transportation according to their working hours and travel requirements.",
topPlaces: [
{
title: "EON IT Park Kharadi",
description: "EON IT Park is one of the most important corporate and technology destinations in Kharadi, with a large workforce travelling from different parts of Pune. Citysky Cabs can arrange scheduled employee pickup and drop, executive transportation, airport transfers, client travel, and regular office cab services for companies operating within and around the IT park."
},
{
title: "World Trade Center Pune",
description: "World Trade Center Pune in Kharadi is a prominent business destination with corporate offices and professional establishments. Corporate cab services can support employees, executives, clients, and business visitors travelling to this commercial hub, with planned pickups, office drops, meetings, airport transfers, and recurring transportation."
},
{
title: "Kharadi IT Park",
description: "Kharadi IT Park and its surrounding office clusters generate regular employee commuting requirements throughout the working week. Citysky Cabs can provide corporate vehicles for daily office routes, shift-based transportation, employee pickup and drop, business meetings, and scheduled travel between Kharadi and other Pune locations."
},
{
title: "Pune International Airport",
description: "Pune International Airport is conveniently connected with Kharadi and is frequently used by corporate employees, executives, clients, and visiting professionals. Corporate airport cab services can be arranged for scheduled pickups and drops between Kharadi offices, hotels, residential areas, and the airport."
},
{
title: "Viman Nagar",
description: "Viman Nagar is an important commercial and residential area near Kharadi and Pune Airport. Corporate cab services can connect employees and business travellers between Kharadi offices and Viman Nagar hotels, residences, commercial establishments, airport routes, and meeting locations according to their daily schedules."
},
{
title: "Hadapsar",
description: "Hadapsar is a major employment and residential corridor connected with Kharadi through important Pune routes. Employee transportation can be arranged between Hadapsar and Kharadi offices with planned pickup points, office drop schedules, suitable vehicles, and professional drivers for regular corporate commuting."
},
{
title: "Magarpatta City",
description: "Magarpatta City is another prominent corporate destination in the eastern Pune business corridor. Citysky Cabs can arrange corporate travel between Kharadi and Magarpatta for employees, executives, meetings, client visits, office transfers, and business appointments with flexible scheduling."
},
{
title: "Koregaon Park",
description: "Koregaon Park has premium hotels, restaurants, commercial establishments, and venues frequently used for professional meetings and business gatherings. Corporate cab services from Kharadi can support executives, clients, and visiting guests travelling between offices, hotels, meeting venues, and other business destinations."
},
{
title: "Wagholi",
description: "Wagholi is a growing residential and commercial area with many employees travelling toward Kharadi's corporate offices every day. Employee pickup and drop services can be organized around office timings, residential pickup points, shift schedules, and suitable vehicle capacities for regular corporate commuting."
},
{
title: "Kalyani Nagar",
description: "Kalyani Nagar is a well-connected commercial and residential destination near Kharadi with offices, hotels, restaurants, and business facilities. Corporate cabs can be used for employee travel, executive movement, guest pickups, meetings, airport transfers, and scheduled business transportation between Kharadi and Kalyani Nagar."
}
],
services: [
{
name: "Corporate Cab Kharadi Pune",
description: "Citysky Cabs offers corporate cab services in Kharadi for companies requiring dependable transportation for employees, executives, clients, and business guests. Vehicles can be arranged for office commuting, employee pickup and drop, meetings, airport transfers, and regular corporate travel."
},
{
name: "Corporate Taxi Kharadi Pune",
description: "Corporate taxi services in Kharadi provide convenient transportation for professionals travelling to offices, meetings, airports, hotels, and business destinations. Citysky Cabs can coordinate suitable vehicles and drivers according to company schedules, passenger requirements, and planned travel routes."
},
{
name: "Corporate Cab Booking Kharadi",
description: "Corporate cab booking in Kharadi allows businesses to arrange transportation in advance for employees, executives, clients, and visitors. Citysky Cabs can coordinate pickup points, destinations, travel timings, vehicle preferences, and driver requirements for scheduled corporate journeys."
},
{
name: "Corporate Cab Rental Kharadi Pune",
description: "Corporate cab rental in Kharadi is suitable for companies needing vehicles for daily office travel, meetings, airport transfers, employee movement, and business events. Citysky Cabs can arrange flexible rental options based on the duration, route, passenger count, and purpose of travel."
},
{
name: "Employee Transportation Kharadi Pune",
description: "Employee transportation services help companies manage regular staff movement between residential areas and Kharadi offices. Citysky Cabs can coordinate employee routes, multiple pickup points, office timings, shift schedules, vehicle capacity, and driver arrangements for organized daily commuting."
},
{
name: "Office Pickup Drop Kharadi Pune",
description: "Office pickup and drop services in Kharadi are designed for employees who need consistent transportation between their homes and workplaces. Citysky Cabs can arrange recurring routes with planned pickup locations, office drop timings, comfortable vehicles, and professional drivers."
},
{
name: "Corporate Employee Cab Kharadi",
description: "Corporate employee cabs provide companies with a practical transportation option for staff members travelling to and from Kharadi offices. Services can be planned around employee residential locations, working hours, shift timings, and vehicle requirements for recurring office commuting."
},
{
name: "IT Company Cab Service Kharadi",
description: "IT companies operating in Kharadi can use dedicated cab services for employee commuting, shift transportation, executive travel, airport movement, and client visits. Citysky Cabs can support recurring office routes and flexible transportation requirements based on company schedules."
},
{
name: "Corporate Office Taxi Kharadi",
description: "Corporate office taxi services in Kharadi can help organizations arrange convenient transportation for employees, managers, clients, and visitors. Vehicles can be scheduled for office pickup and drop, meetings, airport transfers, business appointments, and other professional travel requirements."
},
{
name: "Monthly Corporate Cab Kharadi",
description: "Monthly corporate cab services can help Kharadi businesses manage recurring transportation over an extended period. Citysky Cabs can arrange monthly vehicle and driver requirements for employee commuting, executive travel, airport transfers, office routes, and regular corporate journeys."
},
{
name: "Daily Office Cab Kharadi",
description: "Daily office cab services are suitable for employees and companies requiring regular transportation throughout the working week. Citysky Cabs can arrange scheduled pickup and drop routes from residential areas to Kharadi offices, including suitable vehicles and professional driver support."
},
{
name: "Corporate Airport Cab Kharadi",
description: "Corporate airport cabs from Kharadi provide convenient transportation for executives, employees, clients, and visiting professionals travelling through Pune Airport. Citysky Cabs can coordinate airport pickups and drops according to flight schedules, office timings, hotel locations, and business itineraries."
},
{
name: "Corporate Outstation Cab Kharadi",
description: "Corporate outstation cabs from Kharadi are useful for employees and executives travelling to other cities for meetings, site visits, conferences, client appointments, and business assignments. Citysky Cabs can arrange one-way or round-trip vehicles according to the corporate travel schedule."
},
{
name: "AC Corporate Cab Kharadi",
description: "AC corporate cabs provide a comfortable travel environment for employees, executives, clients, and business guests travelling around Kharadi and beyond. Citysky Cabs can arrange air-conditioned vehicles for office commuting, meetings, airport transfers, events, and outstation business journeys."
},
{
name: "Affordable Corporate Cab Kharadi",
description: "Companies looking for affordable corporate cab services in Kharadi can discuss their employee count, travel routes, vehicle requirements, and service frequency with Citysky Cabs. Transportation arrangements can be planned around practical business requirements while maintaining comfortable travel and dependable driver support."
},
{
name: "Corporate Cab with Driver Kharadi",
description: "Corporate cab with driver services allow employees, executives, and business guests to travel conveniently without handling the vehicle themselves. Citysky Cabs can arrange professional drivers for office travel, meetings, airport transfers, client visits, and scheduled corporate journeys."
},
{
name: "Company Employee Transport Kharadi",
description: "Company employee transport services can help organizations manage regular staff movement between residential locations and Kharadi offices. Citysky Cabs can coordinate employee routes, pickup points, working hours, shifts, vehicle capacity, and driver requirements for structured corporate transportation."
},
{
name: "Corporate Cab Service Near Me Kharadi",
description: "Businesses searching for corporate cab service near their Kharadi location can arrange transportation according to their office address, employee pickup points, and business destinations. Citysky Cabs can support daily commuting, airport travel, meetings, guest transfers, and outstation corporate requirements."
},
{
name: "Business Travel Cab Kharadi",
description: "Business travel cabs in Kharadi are useful for professionals travelling to meetings, offices, hotels, airports, conferences, and client locations. Citysky Cabs can arrange vehicles according to the business itinerary, passenger requirements, pickup schedule, and destination."
},
{
name: "Corporate Guest Pickup Kharadi",
description: "Corporate guest pickup services help companies arrange comfortable transportation for visiting clients, executives, consultants, and business partners. Citysky Cabs can coordinate pickups from Pune Airport, railway stations, hotels, residences, and other locations before transferring guests to Kharadi offices or meeting venues."
},
{
name: "Corporate Cab for EON IT Park Kharadi",
description: "Corporate cab services for EON IT Park Kharadi can support the large number of employees and professionals travelling to this major business destination. Citysky Cabs can arrange employee pickup and drop, executive travel, airport transfers, client visits, and recurring office transportation."
},
{
name: "Office Staff Transportation Kharadi",
description: "Office staff transportation in Kharadi helps companies organize daily movement for employees working at different shifts and schedules. Citysky Cabs can coordinate recurring pickup locations, office drop points, employee routes, vehicle capacity, and professional drivers for convenient staff commuting."
},
{
name: "Corporate Taxi Rental Kharadi",
description: "Corporate taxi rental in Kharadi provides businesses with flexible access to vehicles for employee travel, meetings, airport transfers, client visits, and office requirements. Citysky Cabs can arrange taxis for short-duration requirements as well as recurring corporate transportation."
},
{
name: "Employee Pickup Drop Service Kharadi",
description: "Employee pickup drop services can simplify daily commuting for staff members working in Kharadi offices and IT companies. Citysky Cabs can arrange scheduled residential pickups and office drops based on working hours, shift timings, route requirements, and employee locations."
},
{
name: "Corporate Car Rental Kharadi",
description: "Corporate car rental in Kharadi provides companies with a convenient vehicle option for employees, executives, clients, and business visitors. Cars can be arranged for office travel, meetings, airport transfers, events, local business movement, and outstation assignments with professional driver support."
}
],
tableData: [
["Corporate Cab Kharadi Pune"],
["Corporate Taxi Kharadi Pune"],
["Corporate Cab Booking Kharadi"],
["Corporate Cab Rental Kharadi Pune"],
["Employee Transportation Kharadi Pune"],
["Office Pickup Drop Kharadi Pune"],
["Corporate Employee Cab Kharadi"],
["IT Company Cab Service Kharadi"],
["Corporate Office Taxi Kharadi"],
["Monthly Corporate Cab Kharadi"],
["Daily Office Cab Kharadi"],
["Corporate Airport Cab Kharadi"],
["Corporate Outstation Cab Kharadi"],
["AC Corporate Cab Kharadi"],
["Affordable Corporate Cab Kharadi"],
["Corporate Cab with Driver Kharadi"],
["Company Employee Transport Kharadi"],
["Corporate Cab Service Near Me Kharadi"],
["Business Travel Cab Kharadi"],
["Corporate Guest Pickup Kharadi"],
["Corporate Cab for EON IT Park Kharadi"],
["Office Staff Transportation Kharadi"],
["Corporate Taxi Rental Kharadi"],
["Employee Pickup Drop Service Kharadi"],
["Corporate Car Rental Kharadi"]
],
whychoose: [
{
WhyChooseheading: "Specialized Kharadi Corporate Coverage",
WhyChoosedescription: "Kharadi has a large concentration of IT companies, corporate offices, commercial establishments, and residential communities. Citysky Cabs can support businesses with transportation arrangements designed around Kharadi office routes, employee commuting patterns, airport travel, meetings, and business visitor requirements."
},
{
WhyChooseheading: "Reliable Employee Pickup and Drop",
WhyChoosedescription: "Daily employee commuting becomes easier when residential pickup points and office drop locations are planned in advance. Citysky Cabs can coordinate recurring routes for Kharadi employees with suitable timings, vehicle capacities, and professional drivers according to company schedules."
},
{
WhyChooseheading: "EON IT Park Transportation",
WhyChoosedescription: "Businesses located in and around EON IT Park can arrange corporate cabs for employees, executives, clients, and visitors. Citysky Cabs can support office pickup and drop, airport transfers, business meetings, guest transportation, and recurring routes connected with the IT park."
},
{
WhyChooseheading: "Convenient Airport Transfers",
WhyChoosedescription: "Kharadi's proximity to Pune Airport makes airport transportation an important requirement for many companies. Corporate cabs can be scheduled for employees, executives, clients, and visiting professionals travelling between offices, hotels, residences, and the airport according to their flight timings."
},
{
WhyChooseheading: "Professional Driver Support",
WhyChoosedescription: "Corporate employees and executives can focus on their work while travelling when a professional driver handles the journey. Citysky Cabs can arrange driver-supported vehicles for office commuting, meetings, airport transfers, client pickups, events, and business travel from Kharadi."
},
{
WhyChooseheading: "Daily and Monthly Options",
WhyChoosedescription: "Different companies have different transportation patterns, from occasional business trips to regular employee commuting. Citysky Cabs can arrange daily or monthly corporate cab requirements based on travel frequency, employee routes, rental duration, vehicle category, and business schedules."
},
{
WhyChooseheading: "Local and Outstation Business Travel",
WhyChoosedescription: "Corporate transportation from Kharadi may involve local Pune journeys as well as outstation trips for meetings, site visits, conferences, and client assignments. Citysky Cabs can arrange suitable vehicles for both local and intercity corporate travel according to the planned itinerary."
},
{
WhyChooseheading: "Suitable Vehicles for Corporate Requirements",
WhyChoosedescription: "Employee groups, executives, clients, and business guests can have different vehicle requirements depending on passenger count and travel purpose. Citysky Cabs can help arrange suitable AC cars and corporate vehicles for office routes, airport transfers, guest pickups, meetings, and other professional transportation needs."
}
]
};






const faqData = [
{
question: "How can I arrange Corporate Cab Service in Kharadi with Citysky Cabs?",
answer: "Companies can enquire about corporate cab transportation in Kharadi by sharing employee pickup locations, office destinations, travel timings, passenger count, and regular or one-time travel requirements. Citysky Cabs can review these details and discuss a suitable cab arrangement for the business."
},
{
question: "Can companies arrange employee transportation in Kharadi?",
answer: "Businesses located in and around Kharadi can enquire about cab transportation for employees travelling between their homes, offices, business parks, and other work locations. Pickup points, office timings, employee count, and regular routes can be shared with Citysky Cabs when discussing the transportation requirement."
},
{
question: "Can corporate cabs in Kharadi be used for airport transfers?",
answer: "Corporate travellers can arrange cab transportation between Kharadi and Pune Airport for employees, executives, clients, or visiting business partners. Flight details, pickup location, passenger count, and preferred timing can be provided to Citysky Cabs to discuss the airport transfer."
},
{
question: "Can I book a corporate cab from Kharadi for business meetings?",
answer: "Professionals can use dedicated cab transportation for meetings, client appointments, office visits, conferences, and other business activities. Companies can share the pickup point, meeting destination, travel schedule, and passenger details so Citysky Cabs can understand the required transportation arrangement."
},
{
question: "Can companies arrange regular cab services from Kharadi?",
answer: "Businesses requiring recurring employee transportation can enquire about a regular cab arrangement based on their working days and office timings. Citysky Cabs can consider employee pickup locations, destination, number of passengers, and recurring travel schedules while discussing the corporate service."
},
{
question: "Can a corporate cab from Kharadi be used for Pune to Mumbai travel?",
answer: "Employees and executives travelling from Kharadi to Mumbai for meetings, conferences, client visits, or office work can enquire about an intercity cab. Citysky Cabs can consider the Kharadi pickup location, Mumbai destination, passenger count, and required departure time when discussing the trip."
},
{
question: "Can corporate clients arrange cabs for visiting executives in Kharadi?",
answer: "Companies can arrange dedicated transportation for visiting executives, clients, consultants, and business partners staying in or travelling through Kharadi. The itinerary can include airport pickup, hotel transfers, office visits, meetings, and other business destinations according to the visitor's schedule."
},
{
question: "Can groups of employees travel together in one corporate cab from Kharadi?",
answer: "Employees following the same route can enquire about travelling together by sharing the group size and luggage requirements. Citysky Cabs can consider the number of passengers when discussing an appropriate vehicle for transportation between Kharadi and the required business destination."
},
{
question: "Can corporate cabs in Kharadi be used for business events?",
answer: "Companies organizing conferences, training sessions, seminars, exhibitions, and corporate gatherings can enquire about cab transportation for employees and guests. Providing the event venue, pickup points, participant count, and timings helps Citysky Cabs understand the transportation requirement."
},
{
question: "What details are required to book a Corporate Cab Service in Kharadi?",
answer: "Companies can provide the Kharadi pickup address, destination, travel date, preferred timing, passenger count, employee pickup points, and whether the service is required for regular commuting, airport travel, business meetings, or outstation travel. These details help Citysky Cabs discuss the appropriate corporate cab arrangement."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Ritesh Pawar",
feedback:
"Our office is based in Kharadi and we needed transportation for employees attending meetings at different business locations in Pune. I shared the pickup points and office schedule with Citysky Cabs. Having the cab arrangement planned around our work timings made it easier for the team to coordinate their daily business travel.",
rating: 5
},
{
id: 2,
name: "Miss. Simran Shah",
feedback:
"We had a visiting client arriving at Pune Airport for a meeting at our Kharadi office. I provided the flight details, pickup information, and office address to Citysky Cabs. The direct airport-to-office cab arrangement was convenient and helped us keep the client's visit aligned with our meeting schedule.",
rating: 5
}
];
























































































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Kharadi",
  "image": "https://www.cityskycab.in/assets/images/corporate-cab-service-in-kharadi.webp",
  "description": "Corporate Cab Service in Kharadi from Citysky Cabs provides professional employee transportation, office pickup and drop, corporate taxi, monthly cab rental, airport transfer and outstation business travel solutions for companies and IT offices in Kharadi, Pune. Services include Corporate Cab Kharadi Pune, Corporate Taxi Kharadi Pune, Corporate Cab Booking Kharadi, Corporate Cab Rental Kharadi Pune, Employee Transportation Kharadi Pune, Office Pickup Drop Kharadi Pune, Corporate Employee Cab Kharadi, IT Company Cab Service Kharadi, Corporate Office Taxi Kharadi, Monthly Corporate Cab Kharadi, Daily Office Cab Kharadi, Corporate Airport Cab Kharadi and Corporate Outstation Cab Kharadi. Choose sedan, Ertiga, Kia Carens, Innova and Innova Crysta vehicles for daily, monthly, airport and outstation corporate transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/corporate-cab-service-in-kharadi"
  }
};



    return (
        <div>


<Helmet>
  <title>
    Corporate Cab Service in Kharadi | Employee Transport | +91 8554819191
  </title>

  <meta
    name="description"
    content="Corporate Cab Service in Kharadi by Citysky Cabs for employee pickup-drop, IT offices, monthly cabs, airport transfers and corporate outstation travel."
  />

  <meta
    name="keywords"
    content="Corporate Cab Service in Kharadi, Corporate Cab Kharadi Pune, Corporate Taxi Kharadi Pune, Corporate Cab Booking Kharadi, Corporate Cab Rental Kharadi Pune, Employee Transportation Kharadi Pune, Office Pickup Drop Kharadi Pune, Corporate Employee Cab Kharadi, IT Company Cab Service Kharadi, Corporate Office Taxi Kharadi, Monthly Corporate Cab Kharadi, Daily Office Cab Kharadi, Corporate Airport Cab Kharadi, Corporate Outstation Cab Kharadi, Corporate Cab Service Kharadi, Corporate Cab Services Kharadi, Corporate Taxi Service Kharadi, Corporate Taxi Services Kharadi, Corporate Cab Service Kharadi Pune, Corporate Cab Services Kharadi Pune, Corporate Taxi Service Kharadi Pune, Corporate Taxi Services Kharadi Pune, Kharadi Corporate Cab Service, Kharadi Corporate Taxi Service, Kharadi Corporate Cab Pune, Kharadi Corporate Taxi Pune, Corporate Cab in Kharadi, Corporate Taxi in Kharadi, Corporate Cab in Kharadi Pune, Corporate Taxi in Kharadi Pune, Corporate Cab Company Kharadi, Corporate Taxi Company Kharadi, Corporate Cab Provider Kharadi, Corporate Taxi Provider Kharadi, Corporate Cab Service Provider Kharadi, Corporate Taxi Service Provider Kharadi, Corporate Cab Vendor Kharadi, Corporate Taxi Vendor Kharadi, Corporate Transport Vendor Kharadi, Corporate Transportation Kharadi, Corporate Transportation Service Kharadi, Corporate Transport Service Kharadi, Corporate Mobility Service Kharadi, Corporate Mobility Solutions Kharadi, Corporate Travel Service Kharadi, Corporate Travel Company Kharadi, Business Cab Service Kharadi, Business Taxi Service Kharadi, Business Car Rental Kharadi, Business Transportation Kharadi, Company Cab Service Kharadi, Company Taxi Service Kharadi, Company Car Rental Kharadi, Company Transportation Kharadi, Cab Service for Companies Kharadi, Taxi Service for Companies Kharadi, Car Rental for Companies Kharadi, Corporate Cab Booking Kharadi Pune, Corporate Taxi Booking Kharadi Pune, Corporate Cab Online Booking Kharadi, Corporate Taxi Online Booking Kharadi, Online Corporate Cab Booking Kharadi, Online Corporate Taxi Booking Kharadi, Book Corporate Cab Kharadi, Book Corporate Taxi Kharadi, Corporate Cab Hire Kharadi, Corporate Taxi Hire Kharadi, Corporate Car Rental Kharadi, Corporate Car Hire Kharadi, Corporate Car Booking Kharadi, Corporate Vehicle Rental Kharadi, Corporate Vehicle Hire Kharadi, Corporate Cab Rental Kharadi, Corporate Taxi Rental Kharadi, Corporate Cab Rental Service Kharadi, Corporate Car Rental Service Kharadi, Corporate Cab Rental Kharadi Pune, Corporate Taxi Rental Kharadi Pune, Corporate Car Rental Kharadi Pune, Corporate Car Hire Kharadi Pune, Corporate Cab with Driver Kharadi, Corporate Taxi with Driver Kharadi, Corporate Car with Driver Kharadi, Corporate Car Rental with Driver Kharadi, Corporate Chauffeur Service Kharadi, Best Corporate Cab Service Kharadi, Best Corporate Taxi Service Kharadi, Best Corporate Cab Service Kharadi Pune, Best Corporate Taxi Service Kharadi Pune, Reliable Corporate Cab Kharadi, Reliable Corporate Taxi Kharadi, Professional Corporate Cab Kharadi, Professional Corporate Taxi Kharadi, Affordable Corporate Cab Kharadi, Affordable Corporate Taxi Kharadi, 24x7 Corporate Cab Service Kharadi, 24x7 Corporate Taxi Service Kharadi, Corporate Cab Service Near Me Kharadi, Corporate Taxi Service Near Me Kharadi, Corporate Cab Contact Number Kharadi, Corporate Taxi Contact Number Kharadi, Employee Transportation Kharadi Pune, Employee Transportation Kharadi, Employee Transport Kharadi, Employee Transportation Service Kharadi, Employee Transport Service Kharadi, Employee Cab Service Kharadi, Employee Taxi Service Kharadi, Employee Cab Kharadi, Employee Taxi Kharadi, Employee Cab Rental Kharadi, Employee Taxi Rental Kharadi, Employee Car Rental Kharadi, Employee Pickup Drop Kharadi, Employee Pickup and Drop Kharadi, Employee Pick and Drop Kharadi, Employee Pickup Drop Service Kharadi, Employee Pickup and Drop Service Kharadi, Employee Pickup Drop Cab Kharadi, Employee Pickup Drop Taxi Kharadi, Employee Commute Service Kharadi, Employee Commute Cab Kharadi, Employee Commute Taxi Kharadi, Employee Office Transportation Kharadi, Employee Office Cab Service Kharadi, Corporate Employee Cab Kharadi, Corporate Employee Taxi Kharadi, Corporate Employee Cab Service Kharadi, Corporate Employee Taxi Service Kharadi, Corporate Employee Transportation Kharadi, Corporate Employee Transport Kharadi, Corporate Employee Transportation Service Kharadi, Corporate Employee Pickup Drop Kharadi, Corporate Employee Pickup and Drop Kharadi, Corporate Employee Pickup Drop Service Kharadi, Corporate Employee Cab Rental Kharadi, Corporate Employee Car Rental Kharadi, Staff Transportation Kharadi, Staff Transport Service Kharadi, Staff Cab Service Kharadi, Staff Taxi Service Kharadi, Staff Pickup Drop Kharadi, Staff Pickup Drop Service Kharadi, Corporate Staff Transportation Kharadi, Corporate Staff Cab Service Kharadi, Company Employee Transportation Kharadi, Company Employee Cab Service Kharadi, Company Staff Transportation Kharadi, Company Staff Cab Service Kharadi, Office Pickup Drop Kharadi Pune, Office Pickup Drop Kharadi, Office Pickup and Drop Kharadi, Office Pick and Drop Kharadi, Office Pickup Drop Service Kharadi, Office Pickup and Drop Service Kharadi, Office Pickup Drop Cab Kharadi, Office Pickup Drop Taxi Kharadi, Office Cab Service Kharadi, Office Taxi Service Kharadi, Office Cab Kharadi, Office Taxi Kharadi, Office Cab Booking Kharadi, Office Taxi Booking Kharadi, Office Cab Rental Kharadi, Office Car Rental Kharadi, Office Transportation Kharadi, Office Transportation Service Kharadi, Office Commute Service Kharadi, Office Employee Transportation Kharadi, Office Staff Transportation Kharadi, Corporate Office Cab Kharadi, Corporate Office Taxi Kharadi, Corporate Office Cab Service Kharadi, Corporate Office Taxi Service Kharadi, Corporate Office Transportation Kharadi, Corporate Office Pickup Drop Kharadi, Corporate Office Pickup and Drop Kharadi, Daily Office Cab Kharadi, Daily Office Taxi Kharadi, Daily Office Cab Service Kharadi, Daily Office Taxi Service Kharadi, Daily Office Cab Rental Kharadi, Daily Office Transportation Kharadi, Daily Office Pickup Drop Kharadi, Daily Office Pickup and Drop Kharadi, Daily Employee Cab Kharadi, Daily Employee Taxi Kharadi, Daily Employee Transportation Kharadi, Daily Staff Cab Kharadi, Daily Staff Transportation Kharadi, Daily Corporate Cab Kharadi, Daily Corporate Taxi Kharadi, Daily Corporate Transportation Kharadi, Monthly Corporate Cab Kharadi, Monthly Corporate Taxi Kharadi, Monthly Corporate Cab Service Kharadi, Monthly Corporate Taxi Service Kharadi, Monthly Corporate Cab Rental Kharadi, Monthly Corporate Car Rental Kharadi, Monthly Corporate Transportation Kharadi, Monthly Corporate Employee Transportation Kharadi, Monthly Office Cab Kharadi, Monthly Office Taxi Kharadi, Monthly Office Cab Service Kharadi, Monthly Office Taxi Service Kharadi, Monthly Office Cab Rental Kharadi, Monthly Office Car Rental Kharadi, Monthly Office Pickup Drop Kharadi, Monthly Employee Cab Kharadi, Monthly Employee Taxi Kharadi, Monthly Employee Transportation Kharadi, Monthly Employee Pickup Drop Kharadi, Monthly Staff Cab Kharadi, Monthly Staff Transportation Kharadi, Monthly Cab Service Kharadi, Monthly Taxi Service Kharadi, Monthly Cab Rental Kharadi, Monthly Car Rental Kharadi, Monthly Cab Hire Kharadi, Long Term Corporate Cab Rental Kharadi, Long Term Corporate Car Rental Kharadi, IT Company Cab Service Kharadi, IT Company Taxi Service Kharadi, IT Company Car Rental Kharadi, IT Company Transportation Kharadi, IT Company Employee Transportation Kharadi, IT Company Employee Cab Service Kharadi, IT Company Employee Taxi Service Kharadi, IT Company Staff Transportation Kharadi, IT Company Staff Cab Service Kharadi, IT Office Cab Service Kharadi, IT Office Taxi Service Kharadi, IT Office Transportation Kharadi, Corporate Cab Service for IT Company Kharadi, Corporate Taxi Service for IT Company Kharadi, Corporate Car Rental for IT Company Kharadi, Cab Service for IT Companies Kharadi, Taxi Service for IT Companies Kharadi, Employee Transportation for IT Companies Kharadi, Corporate Cab Service for MNC Kharadi, MNC Cab Service Kharadi, MNC Taxi Service Kharadi, MNC Employee Transportation Kharadi, MNC Staff Transportation Kharadi, Corporate Cab Service for BPO Kharadi, BPO Cab Service Kharadi, BPO Taxi Service Kharadi, BPO Employee Transportation Kharadi, BPO Staff Transportation Kharadi, Corporate Cab Service for Startup Kharadi, Startup Cab Service Kharadi, Startup Employee Transportation Kharadi, Corporate Airport Cab Kharadi, Corporate Airport Taxi Kharadi, Corporate Airport Cab Service Kharadi, Corporate Airport Taxi Service Kharadi, Corporate Airport Cab Booking Kharadi, Corporate Airport Taxi Booking Kharadi, Corporate Airport Transfer Kharadi, Corporate Airport Pickup Kharadi, Corporate Airport Drop Kharadi, Corporate Airport Pickup Drop Kharadi, Corporate Airport Pickup and Drop Kharadi, Corporate Airport Car Rental Kharadi, Kharadi Corporate Airport Cab, Kharadi Corporate Airport Taxi, Kharadi to Pune Airport Corporate Cab, Kharadi to Pune Airport Corporate Taxi, Kharadi to Pune Airport Corporate Cab Service, Kharadi to Pune Airport Corporate Taxi Service, Kharadi to Pune Airport Corporate Cab Booking, Kharadi to Pune Airport Corporate Taxi Booking, Kharadi to Pune Airport Employee Cab, Kharadi to Pune Airport Business Cab, Kharadi to Pune Airport Executive Cab, Pune Airport to Kharadi Corporate Cab, Pune Airport to Kharadi Corporate Taxi, Pune Airport to Kharadi Corporate Cab Service, Corporate Mumbai Airport Cab Kharadi, Corporate Mumbai Airport Taxi Kharadi, Kharadi to Mumbai Airport Corporate Cab, Kharadi to Mumbai Airport Corporate Taxi, Kharadi to Mumbai Airport Corporate Cab Service, Kharadi to Mumbai Airport Corporate Taxi Service, Kharadi to Mumbai Airport Corporate Cab Booking, Kharadi to Mumbai Airport Corporate Car Rental, Corporate Cab Kharadi to Mumbai Airport, Corporate Taxi Kharadi to Mumbai Airport, Mumbai Airport to Kharadi Corporate Cab, Mumbai Airport to Kharadi Corporate Taxi, Corporate Outstation Cab Kharadi, Corporate Outstation Taxi Kharadi, Corporate Outstation Cab Service Kharadi, Corporate Outstation Taxi Service Kharadi, Corporate Outstation Cab Booking Kharadi, Corporate Outstation Taxi Booking Kharadi, Corporate Outstation Cab Rental Kharadi, Corporate Outstation Car Rental Kharadi, Corporate Outstation Car Hire Kharadi, Corporate Outstation Transportation Kharadi, Corporate Outstation Travel Kharadi, Corporate One Way Outstation Cab Kharadi, Corporate One Way Outstation Taxi Kharadi, Corporate Round Trip Outstation Cab Kharadi, Corporate Round Trip Outstation Taxi Kharadi, Business Trip Cab Kharadi, Business Trip Taxi Kharadi, Business Travel Cab Kharadi, Business Travel Taxi Kharadi, Corporate Business Travel Kharadi, Corporate Intercity Cab Kharadi, Corporate Intercity Taxi Kharadi, Corporate Client Visit Cab Kharadi, Corporate Client Visit Taxi Kharadi, Corporate Meeting Cab Kharadi, Corporate Meeting Taxi Kharadi, Corporate Site Visit Cab Kharadi, Corporate Site Visit Taxi Kharadi, Corporate Event Cab Kharadi, Corporate Event Taxi Kharadi, Corporate Event Transportation Kharadi, Corporate Conference Cab Kharadi, Corporate Seminar Cab Kharadi, Corporate Team Outing Cab Kharadi, Executive Cab Service Kharadi, Executive Taxi Service Kharadi, Executive Car Rental Kharadi, Executive Transportation Kharadi, Corporate Executive Cab Kharadi, Corporate Executive Taxi Kharadi, Corporate Executive Car Rental Kharadi, Management Cab Service Kharadi, Management Car Rental Kharadi, CEO Cab Service Kharadi, Director Cab Service Kharadi, Client Cab Service Kharadi, Client Transportation Kharadi, Guest Cab Service Kharadi, Guest Transportation Kharadi, Corporate Client Pickup Drop Kharadi, Corporate Guest Pickup Drop Kharadi, Corporate Local Cab Service Kharadi, Corporate Local Taxi Service Kharadi, Corporate Local Car Rental Kharadi, Corporate Local Transportation Kharadi, Corporate Full Day Cab Kharadi, Corporate Half Day Cab Kharadi, Corporate 8 Hours Cab Kharadi, Corporate 12 Hours Cab Kharadi, Corporate Sedan Cab Kharadi, Corporate Sedan Taxi Kharadi, Sedan Car Rental for Corporate Kharadi, Swift Dzire Corporate Cab Kharadi, Swift Dzire Corporate Taxi Kharadi, Swift Dzire Corporate Car Rental Kharadi, Hyundai Aura Corporate Cab Kharadi, Hyundai Aura Corporate Taxi Kharadi, Aura Corporate Car Rental Kharadi, Ertiga Corporate Cab Kharadi, Ertiga Corporate Taxi Kharadi, Ertiga Hire for Corporate Kharadi, Ertiga Rental for Corporate Kharadi, Kia Carens Corporate Cab Kharadi, Kia Carens Corporate Taxi Kharadi, Kia Carens Rental for Corporate Kharadi, Innova Corporate Cab Kharadi, Innova Corporate Taxi Kharadi, Innova Rental for Corporate Kharadi, Innova Hire for Corporate Kharadi, Innova Crysta Corporate Cab Kharadi, Innova Crysta Corporate Taxi Kharadi, Innova Crysta Rental for Corporate Kharadi, Innova Crysta Hire for Corporate Kharadi, Corporate SUV Cab Kharadi, Corporate SUV Taxi Kharadi, Corporate SUV Rental Kharadi, Corporate Premium Cab Kharadi, Corporate Luxury Cab Kharadi, Corporate Cab Service EON IT Park Kharadi, Corporate Taxi Service EON IT Park Kharadi, Employee Transportation EON IT Park Kharadi, Employee Cab Service EON IT Park Kharadi, Office Pickup Drop EON IT Park Kharadi, Corporate Cab EON IT Park Pune, Corporate Cab Service World Trade Center Kharadi, Corporate Taxi Service World Trade Center Kharadi, Employee Transportation World Trade Center Kharadi, Employee Cab Service World Trade Center Kharadi, Office Pickup Drop World Trade Center Kharadi, Corporate Cab WTC Kharadi, Corporate Taxi WTC Kharadi, Corporate Cab Service Zensar Kharadi, Corporate Taxi Service Zensar Kharadi, Employee Transportation Zensar Kharadi, Corporate Cab Service Kharadi IT Park, Corporate Taxi Service Kharadi IT Park, Employee Transportation Kharadi IT Park, Office Cab Service Kharadi IT Park, Corporate Cab Service Kharadi Bypass, Corporate Taxi Service Kharadi Bypass, Corporate Cab Service Kharadi Pune 411014, Corporate Taxi Service Kharadi Pune 411014, Employee Transportation Kharadi Pune 411014, Corporate Cab Service Chandan Nagar Kharadi, Corporate Taxi Service Chandan Nagar Kharadi, Employee Transportation Chandan Nagar Kharadi, Corporate Cab Service Kharadi to Hinjewadi, Corporate Taxi Kharadi to Hinjewadi, Employee Cab Kharadi to Hinjewadi, Office Cab Kharadi to Hinjewadi, Corporate Cab Kharadi to Baner, Corporate Taxi Kharadi to Baner, Corporate Cab Kharadi to Wakad, Corporate Taxi Kharadi to Wakad, Corporate Cab Kharadi to Magarpatta, Corporate Taxi Kharadi to Magarpatta, Corporate Cab Kharadi to Hadapsar, Corporate Taxi Kharadi to Hadapsar, Corporate Cab Kharadi to Viman Nagar, Corporate Taxi Kharadi to Viman Nagar, Corporate Cab Kharadi to Yerawada, Corporate Taxi Kharadi to Yerawada, Corporate Cab Kharadi to Koregaon Park, Corporate Taxi Kharadi to Koregaon Park, Corporate Cab Kharadi to Kalyani Nagar, Corporate Taxi Kharadi to Kalyani Nagar, Corporate Cab Kharadi to Pimpri Chinchwad, Corporate Taxi Kharadi to Pimpri Chinchwad, Corporate Cab Kharadi to Chakan MIDC, Corporate Taxi Kharadi to Chakan MIDC, Corporate Cab Kharadi to Ranjangaon MIDC, Corporate Taxi Kharadi to Ranjangaon MIDC, Corporate Cab Kharadi to Mumbai, Corporate Taxi Kharadi to Mumbai, Corporate Cab Kharadi to Navi Mumbai, Corporate Taxi Kharadi to Navi Mumbai, Corporate Cab Kharadi to Nashik, Corporate Taxi Kharadi to Nashik, Corporate Cab Kharadi to Ahmednagar, Corporate Taxi Kharadi to Ahmednagar, Corporate Cab Kharadi to Sambhajinagar, Corporate Taxi Kharadi to Sambhajinagar, Corporate Cab Kharadi to Satara, Corporate Taxi Kharadi to Satara, Corporate Cab Kharadi to Kolhapur, Corporate Taxi Kharadi to Kolhapur, Corporate Cab Kharadi to Solapur, Corporate Taxi Kharadi to Solapur, Corporate Cab Service Provider in Kharadi, Corporate Taxi Service Provider in Kharadi, Corporate Transportation Service Provider Kharadi, Employee Transportation Service Provider Kharadi, Corporate Car Rental Service Provider Kharadi, Office Cab Service Provider Kharadi, Corporate Cab Company in Kharadi, Corporate Taxi Company in Kharadi, Corporate Transportation Company Kharadi, Employee Transportation Company Kharadi, Corporate Car Rental Company Kharadi, Corporate Travel Company Kharadi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keywords/113.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Corporatecabserviceinkharadi;